import { jsPDF } from "jspdf";
import JsBarcode from "jsbarcode";

const saveShippingLabel = (SN = 'N/A', labelPNG, carrier) => {

	function fillPage (label, crr = 'FEDEX') {
		const labelPNG = 'data:image/png;base64,' + label;
		doc.addImage(labelPNG, 'PNG', 15, 10, 100, 145);
		doc.text(`PACKAGE MUST BE SHIPPED VIA ${crr.toUpperCase()}\nSN: ${SN}`, 15, 180);
		doc.line(15, 181, 128, 181);
	}

	function fillBarcode (SN) {
		const canvas = document.createElement('canvas');
		JsBarcode(canvas, SN, {displayValue: false, width: 1, height: 50, margin: 5})
		doc.addImage(canvas.toDataURL(), "PNG", 60, 182);
		canvas.remove();
	}

	const doc = new jsPDF('landscape');
	doc.setFont("helvetica", "bold");
	doc.setLineWidth(1);
	fillPage(labelPNG, carrier);
	fillBarcode(SN);
	doc.save(SN + '_shipping_label.pdf');
}

export default saveShippingLabel;